import { JSONValue } from "@smile2impress/attraction-constants";

import {
    JSONSchemaServiceProductContent,
    JSONSchemaServiceReviewContent,
} from "../JSONSchemaService.types";

export const ProductJSONSchema = (
    content: JSONSchemaServiceProductContent
): JSONValue => {
    const { datePublished, imageUrl, name, description, pageUrl, reviews } =
        content;

    return {
        "@context": "https://schema.org",
        "@type": "Product",
        name,
        description,
        image: imageUrl,
        brand: {
            "@type": "Organization",
            name: "Impress",
            url: pageUrl,
        },
        datePublished: datePublished,
        ...(reviews
            ? {
                  review: reviews.map((r: JSONSchemaServiceReviewContent) => ({
                      "@type": "Review",
                      author: { "@type": "Person", name: r.authorName },
                      datePublished: r.datePublished,
                      reviewBody: r.text,
                      reviewRating: {
                          "@type": "Rating",
                          ratingValue: r.rating,
                          bestRating: "5",
                          worstRating: "1",
                      },
                  })),
              }
            : {}),
    } as JSONValue;
};
